<template>

  <VUEModal v-if="PopupRemoveRighello" :Titolo="this.GetTraduzioneLabel('Generic','TKN_DATI_RIGHELLO',this.LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupRemoveRighello()">
    <template v-slot:Body>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
        <p style="width: 150px; margin: 0px; display: flex; align-items: center; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_SELEZIONA_RIGHELLO',this.LinguaUtente) }}</p>
        <div style="width: 50%; display: flex; justify-content: space-between">
          <select class="form-control" v-model="RighelloToRemove">
            <option :value="''">-</option>
            <option v-for="Righello in GraphData.ListaRighelli" :key="Righello.PrettyDateTime">{{ Righello.PrettyDateTime }}</option>
          </select>
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupRemoveRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="RighelloToRemove != ''" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupRemoveRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="PopupAddRighello" :Titolo="this.GetTraduzioneLabel('Generic','TKN_DATI_RIGHELLO',this.LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupAddRighello()">
    <template v-slot:Body>
      <div style="font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
          <p style="width: 120px; margin: 0px; display: flex; align-items: center; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_DATA_RIGHELLO',this.LinguaUtente) }}</p>
          <div style="width: 70%; display: flex; justify-content: space-between">
            <input class="form-control" style="width:55%; display: inline" type="date" v-model="ObjNewRighello.Data">
            <input class="form-control" style="width:40%; display: inline" type="time" v-model="ObjNewRighello.Ora">
          </div>
        </div>
        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between; margin-top: 10px">
          <p style="width: 150px; margin: 0px; display: flex; align-items: center; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_COLORE_RIGHELLO',this.LinguaUtente) }}</p>
          <label class="form-control" style="width:20%; cursor: pointer; height: 25px; margin: 0px" :style="{'background' : ObjNewRighello.Colore}" @click="ApriPopupColorPicker(ObjNewRighello.Colore, 'background')">&nbsp;</label>
        </div>            
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupAddRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjNewRighello.Data != '' && ObjNewRighello.Ora != ''" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupAddRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="PopupImpostazioniAsseY" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_Y',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupImpostazioniY()">
    <template v-slot:Body>      
      <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="GraphData.AxisY.Min">
          <p style="width: 15%; margin: 0px; margin-left: 10px; font-weight: bold">{{ '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIGRAMMO',this.LinguaUtente) + ']' }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="GraphData.AxisY.Max">
          <p style="width: 15%; margin: 0px; margin-left: 10px; font-weight: bold">{{ '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIGRAMMO',this.LinguaUtente) + ']' }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="GraphData.AxisY.Udm">
          <p style="width: 15%; margin: 0px; margin-left: 10px; font-weight: bold">{{ '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIGRAMMO',this.LinguaUtente) + ']' }}</p>
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupImpostazioniY()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupImpostazioniY()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="PopupUdmX"
            :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_TEMP_ASSE_X',this.LinguaUtente)"
            :Altezza="'80px'"
            :Larghezza="'500px'"
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            :Programma="'DMSEW'"
            @onClickChiudiModal="AnnullaPopupUdmX()">
    <template v-slot:Body>
      <div style="display: flex; flex-flow: row wrap; align-items: center; justify-content: space-between; height: 100%; padding-left: 30px; padding-right: 30px;">
        <div style="width: 25%">
          <input class="form-control" type="number" style="margin: 0px; width: 70%;" v-model="GraphData.AxisX.UdmX"/>
        </div>
        <div>
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_GIORNI',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioGiorni" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Giorni" v-model="GraphData.AxisX.TipoUdmX"/>
        </div>
        <div>
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE_M',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioOre" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Ore" v-model="GraphData.AxisX.TipoUdmX"/>
        </div>
        <div>
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_MINUTI',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioMinuti" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Minuti" v-model="GraphData.AxisX.TipoUdmX"/>
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupUdmX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="GraphData.AxisX.UdmX > 0" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupUdmX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEColorPicker :Popup="PopupColorPicker" Programma="DMSEW" :Colore="ColoreInModifica" @OnClickConfermaPopup="ConfermaColore()" @OnClickChiudiPopup="AnnullaColore()"></VUEColorPicker>

  <div v-if="IsGraficoModulabile" style="height: 20px; width: 20px; background-color: grey; position: relative; top: 3px; left: 96%; display: flex; align-content: center; justify-content: center; align-items:center; pointer-events: all; cursor: pointer" @click="MenuImpostazioni = !MenuImpostazioni">
    <a class="fa fa-bars" :title="this.GetTraduzioneLabel('Generic','TKN_IMP_GRAF',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>  
    <div v-if="MenuImpostazioni && IsGraficoModulabile" style="width: 20px; position: absolute; top: 25px; pointer-events: all">
      <div v-if="this.IsGraficoEvAccAmpiezza" class="ZMGraficoGenericoBottoni" @click="AdattaGrafico">
        <a class="fa fa-arrows" :title="this.GetTraduzioneLabel('Generic','TKN_ADATTA',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
      <div class="ZMGraficoGenericoBottoni" @click="ApriPopupUdmX">
        <a class="fa fa-sliders" :title="this.GetTraduzioneLabel('Generic','TKN_ASSE_X',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
      <div class="ZMGraficoGenericoBottoni" @click="ApriPopupImpostazioniY">
        <a class="fa fa-sort-amount-asc" :title="this.GetTraduzioneLabel('Generic','TKN_ASSE_Y',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
      <!-- <div class="ZMGraficoGenericoBottoni" @click="ApriPopupAddRighello">
        <a class="fa fa-pencil" :title="this.GetTraduzioneLabel('Generic','TKN_ADD_RIGHELLO',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
      <div v-if="GraphData.ListaRighelli.length != 0" class="ZMGraficoGenericoBottoni" @click="ApriPopupRemoveRighello()">
        <a class="fa fa-times" :title="this.GetTraduzioneLabel('Generic','TKN_DEL_RIGHELLO',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div> -->
      <div class="ZMGraficoGenericoBottoni" @click="EsportaComePDF()">
        <a class="fa fa-file-pdf-o" :title="this.GetTraduzioneLabel('Generic','TKN_EXP_PDF',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
    </div>
  </div> 

  <div ref="ElementoGrafico">  
    <canvas ref="Canvas" :width="WidthGrafico" :height="HeightGrafico + 50"></canvas>
  </div>      
</template>

<script>
// import { TZGraphMarkup, TZGraphLabelType, TZGraphLine, TZGraphNotchType } from '@/utils/ZGraph.js'
import { TZGraphNotchType, TZGraphLabelType, TZGraphMarkup, TZGraphHistogram } from '@/utils/ZGraph.js'
import { MS_X_DAY, TZDateFunct } from '@/utils/ZDateFunct'
import { TInfoGraphic } from '../../InfoGraphic.js'
import { TIPOLOGIA_GRAFICI_STORICI, TIPI_UDM_X, COLORI_PANTONE, SystemInformation, SPESSORE_LINEE_GRAFICI, INTERVALLI_DI_TEMPO } from '@/SystemInformation'
import MixInsGraficiStorici from '@/views/ContentPages/MixInsGraficiStorici'
import { TZMathFunct } from '@/utils/ZMathFunct'
import VUEColorPicker from '@/utils/VUEColorPicker.vue'
import VUEModal from '@/utils/VUEModal.vue'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import { TZGenericFunct } from '@/utils/ZGenericFunct'

export default 
{
  components: { VUEModal, VUEColorPicker },
  mixins: [ MixInsGestioneTraduzioni, MixInsGraficiStorici ],
  data() 
  {
    return {
              TipiUdmX               : TIPI_UDM_X,
              TipiStorici            : TIPOLOGIA_GRAFICI_STORICI,
              SpessoreGrafico        : SPESSORE_LINEE_GRAFICI,
              VentiquattroOre        : INTERVALLI_DI_TEMPO.VentiquattroOre,
              ObjGrafico             : null,
              PopupRemoveRighello    : false,
              PopupAddRighello       : false,
              PopupColorPicker       : false,
              PopupImpostazioniAsseY : false,
              IsGraficoEvAccAmpiezza : false,
              PopupUdmX              : false,
              MenuImpostazioni       : false,
              ObjDati                : null,
              Stacking               : 10,
              RighelloToRemove       : '',
              ObjNewRighello         : {Data: '', Ora : '', DateTime : '',  PrettyDateTime: '', Colore: '#000000'},
              ColoreInModifica       : {Colore: '#000000'},
              Grafici                : {},
              LinguaUtente           : SystemInformation.UserInformation.Lingua
           }

  },
  props: [ "WidthGrafico", "HeightGrafico", "Sensore", "ObjDal", "ObjAl", "TipoGrafico", "PropsGrafico", "Repaint", "RepaintDeep", "IsGraficoModulabile", "ColoreFreq", "DescrizioneSitoPDF", "OggettoDati", "AddDatiPDF", "CatenaInfo", "SoglieEvAcc"],

  methods:
  {
    GetMaxAxisY()
    {
      let Result = 0
      if(this.Sensore != undefined)
      {
        for(let i = 0; i < this.Sensore.Dati.length; i++)
        {
          if(Result < this.Sensore.Dati[i].Pitch)
            Result = this.Sensore.Dati[i].Pitch
        }
      }
      return Result
    },

    GetMinAxisY()
    {
      let Result = 0
      if(this.Sensore != undefined)
      {
        for(let i = 0; i < this.Sensore.Dati.length; i++)
        {
          if(Result > this.Sensore.Dati[i].Pitch)
            Result = this.Sensore.Dati[i].Pitch
        }
      }
      return Result
    },

    GetMinDelta(Element)
    {
      return Math.min(Math.abs(Element.MaxAccX - Element.MinAccX), Math.abs(Element.MaxAccY - Element.MinAccY), Math.abs(Element.MaxAccZ - Element.MinAccZ))
    },

    GetMaxDelta(Element)
    {
      return Math.max(Math.abs(Element.MaxAccX - Element.MinAccX), Math.abs(Element.MaxAccY - Element.MinAccY), Math.abs(Element.MaxAccZ - Element.MinAccZ))
    },

    GetMaxMin()
    {
      let MinY = 0
      let MaxY = 10
      switch (this.TipoGrafico)
      {
        case TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_A:
        {
          if (this.Sensore.Dati != undefined && this.Sensore.Dati.length != 0)
          {
            let FirstElement = this.Sensore.Dati[0]
            MinY = this.GetMinDelta(FirstElement) // fatto così nel vecchio ew, ma penso inutile
            MaxY = this.GetMaxDelta(FirstElement)
            for (let i = 0; i < this.Sensore.Dati.length; i++)
            {
              MaxY = Math.max(MaxY, this.GetMaxDelta(this.Sensore.Dati[i]))
              MinY = Math.min(MinY, this.GetMinDelta(this.Sensore.Dati[i]))
            }

          }
          break
        }
        case TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_F:
        {
          if (this.Sensore.Dati != undefined && this.Sensore.Dati.length != 0)
          {
            let FirstElement = this.Sensore.Dati[0]
            MinY = 0
            MaxY = FirstElement.Conteggio
            for (let i = 0; i < this.Sensore.Dati.length; i++)
            {
              MaxY = Math.max(MaxY, this.Sensore.Dati[i].Conteggio)
            }
          }
          break
        }
      }
      return {Min : MinY, Max : MaxY}
    },

    Adatta()
    {
      let ObjAsseY = this.GetMaxMin()
      if (ObjAsseY.Min >= 0)
        ObjAsseY.Min = 0
      else
        ObjAsseY.Min = TZMathFunct.GetMultiplo(ObjAsseY.Min, 10, 'Difetto')
      ObjAsseY.Max = TZMathFunct.GetMultiplo(ObjAsseY.Max, 10, 'Eccesso')
      if (ObjAsseY.Max == ObjAsseY.Min)
        ObjAsseY.Max = ObjAsseY.Min + 100
      if (ObjAsseY.Max - ObjAsseY.Min > 500)
        ObjAsseY.Udm = TZMathFunct.GetMultiplo((ObjAsseY.Max / 10), 10, 'Eccesso')
      else
      {
        if (ObjAsseY.Max - ObjAsseY.Min > 100)
        {
          ObjAsseY.Udm = 50
        }
        else
        {
          if (ObjAsseY.Max - ObjAsseY.Min > 50)
          {
            ObjAsseY.Udm = 10
          }
          else
          {
            if (ObjAsseY.Max - ObjAsseY.Min > 10)
            {
              ObjAsseY.Udm = 5
            }
            else
            {
              ObjAsseY.Udm = 1
            }
          }
        }
      }
      this.ObjGrafico.AxisX.Min           = Date.parse(this.ObjDal.Data + 'T' + (this.ObjDal.Ora < 10 ? '0' + this.ObjDal.Ora : this.ObjDal.Ora) + ':00')
      this.ObjGrafico.AxisX.Max           = Date.parse(this.ObjAl.Data + 'T' + (this.ObjAl.Ora < 10 ? '0' + this.ObjAl.Ora : this.ObjAl.Ora) + ':00')
      this.ObjGrafico.AxisX.Max           = this.ObjGrafico.AxisX.Max + TZDateFunct.GetNHoursInTimeStamp(1)
      this.ObjGrafico.AxisX.NotchDim      = (Math.abs(this.ObjGrafico.AxisX.Max - this.ObjGrafico.AxisX.Min))

      if (this.TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_F)
        this.ObjGrafico.AxisX.NotchDim = this.VentiquattroOre
      else this.ObjGrafico.AxisX.NotchDim = TInfoGraphic.GetAdjustedNotchDim(this.ObjGrafico.AxisX.NotchDim, 8)

      // this.ObjGrafico.AxisX.OffsetNotch   = this.ObjGrafico.AxisX.NotchDim

      this.ObjGrafico.AxisY.Max = ObjAsseY.Max
      this.ObjGrafico.AxisY.Min = ObjAsseY.Min
      this.ObjGrafico.AxisY.NotchDim = ObjAsseY.Udm
      this.ObjGrafico.AxisY.FontSize  = 13
      this.PropsGraficoPerModifica.AxisY.Min = ObjAsseY.Min
      this.PropsGraficoPerModifica.AxisY.Max = ObjAsseY.Max
      this.PropsGraficoPerModifica.AxisY.Udm = ObjAsseY.Udm
    },

    AdattaGrafico()
    {
      this.MixInsOnClickAdattaEvAcc(this.PropsGrafico, true)
    },

    ApriPopupUdmX()
    {
      this.PopupUdmX = true
    },

    ConfermaPopupUdmX()
    {
      this.MixInsConfermaPopupUdmXEvAcc(this.PropsGrafico, true)
    },

    AnnullaPopupUdmX()
    {
      this.PopupUdmX = false      
    },

    ApriPopupImpostazioniY()
    {
      this.PopupImpostazioniAsseY = true
    },

    ConfermaPopupImpostazioniY()
    {
      this.MixInsConfermaPopupImpostazioniYEvAcc(true)
    },

    AnnullaPopupImpostazioniY()
    {
      this.PopupImpostazioniAsseY = false
    },

    ApriPopupAddRighello()
    {
      this.PopupAddRighello = true
    },

    EsportaComePDF()
    {
      let ArrayModulo = []
      ArrayModulo.push(TZGenericFunct.GetCopyOfObject(this.Sensore))

      let ArrayOggettoGrafico = []
      ArrayOggettoGrafico.push(TZGenericFunct.GetCopyOfObject(this.GraphData.OggettoGrafico))

      this.MixInsEsportaComePDF(ArrayModulo, true, ArrayOggettoGrafico, this.Sensore.Id)

      // this.MixInsEsportaComePDF(this.Sensore, true, TZGenericFunct.GetCopyOfObject(this.GraphData.OggettoGrafico))
    },

    ConfermaPopupAddRighello()
    {
      this.MixInsConfermaPopupAddRighelloEvAcc(this.PropsGrafico, true)
    },

    AnnullaPopupAddRighello()
    {
      this.PopupAddRighello = false
      this.MixInsResetNewRighelloEvAcc()
    },

    ApriPopupRemoveRighello()
    {
      this.RighelloToRemove = ''
      this.PopupRemoveRighello = true
    },

    ConfermaPopupRemoveRighello()
    {
      this.MixInsConfermaPopupRemoveRighelloEvAcc(this.PropsGrafico, true)
    },

    AnnullaPopupRemoveRighello()
    {
      this.PopupRemoveRighello = false
    },

    ApriPopupColorPicker(Colore)
    {
      this.ColoreInModifica.Colore = Colore
      this.PopupColorPicker = true
    },

    ConfermaColore()
    {
      this.ObjNewRighello.Colore = this.ColoreInModifica.Colore
      this.AnnullaColore()
    },

    AnnullaColore()
    {
      this.ColoreInModifica = {}
      this.PopupColorPicker = false
    },

    InserisciDati()
    {
      this.Grafici = {}
      this.ObjGrafico.ClearAllGroupPoint()
      let ColoreAsseX = this.PropsGrafico.NewColorAmpiezzaX ? this.PropsGrafico.NewColorAmpiezzaX : '#0000ff'
      let ColoreAsseY = this.PropsGrafico.NewColorAmpiezzaY ? this.PropsGrafico.NewColorAmpiezzaY : '#ff0000'
      let ColoreAsseZ = this.PropsGrafico.NewColorAmpiezzaZ ? this.PropsGrafico.NewColorAmpiezzaZ : '#008000'
      
      switch (this.TipoGrafico)
      {
        case TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_A:
        {
          this.Grafici.X = this.ObjGrafico.AddGroupPoint(1, ColoreAsseX, this.SpessoreGrafico, this.PropsGrafico.X ? true : false)
          this.Grafici.Y = this.ObjGrafico.AddGroupPoint(2, ColoreAsseY, this.SpessoreGrafico, this.PropsGrafico.Y ? true : false)
          this.Grafici.Z = this.ObjGrafico.AddGroupPoint(3, ColoreAsseZ, this.SpessoreGrafico, this.PropsGrafico.Z ? true : false)

          if(this.Sensore.Dati != undefined)
            for (let i = 0; i < this.Sensore.Dati.length; i++)
            {
              let Dato = this.Sensore.Dati[i]
              let XCoord = Date.parse(Dato.Data)
              this.Grafici.X.AddPoint(XCoord, Math.abs(Dato.MaxAccX - Dato.MinAccX))
              this.Grafici.Y.AddPoint(XCoord, Math.abs(Dato.MaxAccY - Dato.MinAccY))
              this.Grafici.Z.AddPoint(XCoord, Math.abs(Dato.MaxAccZ - Dato.MinAccZ))
            }
          break
        }
        case TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_F:
        {
          let Grafico
          let ColoreFrequenza = this.PropsGrafico.NewColorFrequenza ? this.PropsGrafico.NewColorFrequenza : COLORI_PANTONE.Arancione
          if(this.IsGraficoModulabile)
            Grafico = this.ObjGrafico.AddGroupPoint(1, this.ColoreFreq, this.SpessoreGrafico, true)
          else Grafico = this.ObjGrafico.AddGroupPoint(1, ColoreFrequenza, this.SpessoreGrafico, true)
          if(this.Sensore.Dati != undefined)
            for (let i = 0; i < this.Sensore.Dati.length; i++)
            {
              let Dato = this.Sensore.Dati[i]
              let XCoord = Date.parse(Dato.Data)
              Grafico.AddPoint(XCoord, Dato.Conteggio)
            }
          break
        }
      }
    },

    Disegna()
    {
      this.Adatta()
      this.InserisciDati()
      setTimeout(() => { this.ObjGrafico.Paint()}, 1)
    },

    DoRepaint()
    {
      if (this.TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_A)
      {
        this.Grafici.X.Visible = this.PropsGrafico.X
        this.Grafici.Y.Visible = this.PropsGrafico.Y
        this.Grafici.Z.Visible = this.PropsGrafico.Z
      }
      this.ObjGrafico.AxisY.Max      = this.PropsGrafico.AxisY.Max
      this.ObjGrafico.AxisY.Min      = this.PropsGrafico.AxisY.Min
      this.ObjGrafico.AxisY.NotchDim = this.PropsGrafico.AxisY.Udm
      
      this.ObjGrafico.ClearListaRighelli()
      for (let i = 0; i < this.PropsGrafico.ListaRighelli.length; i++)
      {
        let Righello                = this.PropsGrafico.ListaRighelli[i]
        let AsseRighello            = this.ObjGrafico.AddRighello()
        AsseRighello.Color          = Righello.Colore
        AsseRighello.ParalleloAsseX = false
        AsseRighello.DistanceFromY  = Date.parse(Righello.DateTime)
      }
      if (this.PropsGrafico.AxisX.Modificato)
      {
        let NewUdm = 0
        switch (this.PropsGrafico.AxisX.TipoUdmX)
        {
          case TIPI_UDM_X.Giorni  : {
                                      NewUdm = this.PropsGrafico.AxisX.UdmX * 86400000
                                      break
                                    }
          case TIPI_UDM_X.Ore     : {
                                      NewUdm = this.PropsGrafico.AxisX.UdmX * 3600000
                                      break
                                    }
          case TIPI_UDM_X.Minuti  : {
                                      NewUdm = this.PropsGrafico.AxisX.UdmX * 60000
                                      break
                                    }
          default                 : NewUdm = this.PropsGrafico.AxisX.UdmX
        }
        this.ObjGrafico.AxisX.OffsetNotch = 0
        this.ObjGrafico.AxisX.NotchDim = NewUdm
      }
      this.InserisciDati()
      if (this.TipoGrafico === TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_A)
          this.RedrawSoglieEvAcc(true)
      setTimeout(() => { this.ObjGrafico.Paint()}, 1)
    },

    AggiungiLineeSoglieEvAcc() 
    {
      if (!this.ObjGrafico) return
      if (!this.SoglieEvAcc) return

      Object.values(this.SoglieEvAcc).forEach(Soglia => 
      {
        if (!Soglia) return
        if (!Soglia.Attiva || !Soglia.Visibile) return
        if (Soglia.Y == null) return

        if (Soglia.Y >= this.ObjGrafico.AxisY.Min && Soglia.Y <= this.ObjGrafico.AxisY.Max) 
        {
          this.ObjGrafico.AddSegmento(
                                       this.ObjGrafico.AxisX.Min,
                                       Soglia.Y,
                                       this.ObjGrafico.AxisX.Max,
                                       Soglia.Y,
                                       '',
                                       true
                                     )

          var Segmento = this.ObjGrafico.ListaSegmenti[this.ObjGrafico.ListaSegmenti.length - 1]
          Segmento.Color = Soglia.Colore
          Segmento.PenWidth = 1.5
          Segmento.PenStyle = []
        }
      })
    },

    RedrawSoglieEvAcc(Active) 
    {
      if (this.TipoGrafico !== TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_A) return
      if (!this.ObjGrafico?.ClearSegmenti) return
      this.ObjGrafico.ClearSegmenti()
      if (Active) this.AggiungiLineeSoglieEvAcc()
      this.ObjGrafico.Paint()
    }
  },

  computed:
  {
    PropsGraficoPerModifica :
    {
      get()
      {
        return this.PropsGrafico
      }
    },    

    GraphData:
    {
      get()
      {
        return this.PropsGrafico
      }
    },
    
    InfoCatena:
    {
      get()
      {
        return this.CatenaInfo
      }
    }
  },

  watch:
  {
    AddDatiPDF:
    {
      handler(NewValue)
      {
        if (NewValue != 0)
        {
          this.InfoCatena.DatiPDF.push(this.MixInsGetDatiPerPDF(true, this.Sensore, TZGenericFunct.GetCopyOfObject(this.GraphData.OggettoGrafico)))
        }
      }
    },

    Repaint:
    {
      handler()
      {
        this.DoRepaint()
      }
    },

    RepaintDeep:
    {
      handler()
      {
        this.Disegna()
      }
    },

    SoglieEvAcc :
    {
      deep : true,
      handler()
      {
        if (this.TipoGrafico !== TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_A) return
        if (!this.ObjGrafico) return
        if (!this.SoglieEvAcc) return
        this.RedrawSoglieEvAcc(true)
      }
    }
  },

  mounted()
  {
    if(this.OggettoDati != null)
    {
      this.ObjDati = this.OggettoDati
      this.ObjDati.TipoGrafico =  this.TipoGrafico
    }

    if(this.IsGraficoModulabile)
    {
      if(this.TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_F)
      {
        this.Sensore.Dati = this.Sensore.DatiEvAccF
        this.Sensore.MaxAdattamentoAsseY = this.Sensore.MaxAdattamentoAsseYFreqAcc
        this.Sensore.MinAdattamentoAsseY = this.Sensore.MinAdattamentoAsseYFreqAcc
        this.Sensore.UdmY = this.Sensore.UdmYFreqAcc
      }
      else
      {
        this.IsGraficoEvAccAmpiezza = true
        this.Sensore.Dati = this.Sensore.DatiEvAccA
        this.Sensore.MaxAdattamentoAsseY = this.Sensore.MaxAdattamentoAsseYAmpAcc
        this.Sensore.MinAdattamentoAsseY = this.Sensore.MinAdattamentoAsseYAmpAcc
        this.Sensore.UdmY = this.Sensore.UdmYAmpAcc
      }
    }

    if (this.TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_F)
    {
      this.ObjGrafico = new TZGraphHistogram(this.$refs.Canvas)
      this.ObjGrafico.AxisY.CenterLabel  = this.GetTraduzioneLabel('VUEComponenteGraficoAccelerometri','TKN_GRAF_ACCEL_FRQ',this.LinguaUtente)
      this.ObjGrafico.PointWidth = MS_X_DAY
      this.ObjGrafico.AxisY.LabelType     = TZGraphLabelType.lblInteger
    }
    else
    {
      this.ObjGrafico = new TZGraphMarkup(this.$refs.Canvas)
      this.ObjGrafico.AxisY.CenterLabel = this.GetTraduzioneLabel('VUEComponenteGraficoAccelerometri','TKN_GRAF_ACCEL_AMP',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIGRAMMO',this.LinguaUtente) + ']'
      this.ObjGrafico.AxisY.LabelType     = TZGraphLabelType.lblDecimi
    }
    if(this.ObjGrafico.AxisY.NotchDim != undefined)
        this.ObjGrafico.AxisY.LabelType    = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))
    this.GraphData.OggettoGrafico = this.ObjGrafico
    this.ObjGrafico.VerticalLabelAxisX = true
    this.ObjGrafico.ShowFirstMarkup     = true
    this.ObjGrafico.AxisX.NotchType     = TZGraphNotchType.notStandard
    this.ObjGrafico.AxisY.NotchType     = TZGraphNotchType.notStandard
    this.ObjGrafico.AxisY.NotchFontSize = 15
    this.ObjGrafico.AxisX.LabelType     = TZGraphLabelType.lblDateTime
    this.ObjGrafico.AxisX.NotchFontSize = 15
    this.ObjGrafico.AxisX.NotchPenWidth = 1
    this.ObjGrafico.AxisY.NotchPenWidth = 1
    this.ObjGrafico.AxisX.NotchColor    = 'grey'
    this.ObjGrafico.AxisY.NotchColor    = 'grey'
    this.ObjGrafico.__Margins.MinLeft   += 30
    this.ObjGrafico.AxisY.FontSize      = 13

    this.ObjGrafico.__Margins.MinBottom += 60
    this.ObjGrafico.AxisX.Min           = Date.parse(this.ObjDal.Data + 'T' + (this.ObjDal.Ora < 10 ? '0' + this.ObjDal.Ora : this.ObjDal.Ora) + ':00')
    this.ObjGrafico.AxisX.Max           = Date.parse(this.ObjAl.Data + 'T' + (this.ObjAl.Ora < 10 ? '0' + this.ObjAl.Ora : this.ObjAl.Ora) + ':00')
    this.ObjGrafico.AxisX.Max           = this.ObjGrafico.AxisX.Max + TZDateFunct.GetNHoursInTimeStamp(1)
    this.ObjGrafico.AxisX.NotchDim      = (Math.abs(this.ObjGrafico.AxisX.Max - this.ObjGrafico.AxisX.Min))
    this.ObjGrafico.AxisX.NotchDim      = TInfoGraphic.GetAdjustedNotchDim(this.ObjGrafico.AxisX.NotchDim, 24)
    // this.ObjGrafico.AxisX.OffsetNotch   = this.ObjGrafico.AxisX.NotchDim

    this.ObjGrafico.AxisY.Max = this.Sensore.MaxAdattamentoAsseY
    this.ObjGrafico.AxisY.Min = this.Sensore.MinAdattamentoAsseY
    this.ObjGrafico.AxisY.NotchDim = this.Sensore.UdmY

    this.PropsGraficoPerModifica.AxisY.Min = this.Sensore.MinAdattamentoAsseY
    this.PropsGraficoPerModifica.AxisY.Max = this.Sensore.MaxAdattamentoAsseY
    this.PropsGraficoPerModifica.AxisY.Udm = this.Sensore.UdmY

    this.Adatta()
    this.InserisciDati()
    setTimeout(() => { this.ObjGrafico.Paint()}, 1)

    setTimeout(() => { 
                       if (this.TipoGrafico === TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_A)
                           this.RedrawSoglieEvAcc(true) 
                     }, 500)
  },

  beforeMount()
  {    
  },
}
</script>